import './TrayVisualization.scss'
import useTrayVisualizationLogic from './TrayVisualization.logic'
import TrayProcedureEditMode from 'components/organisms/TrayProcedureEditMode/TrayProcedureEditMode'
import { TransformWrapper } from 'react-zoom-pan-pinch'
import FullScreenDialog from 'components/organisms/FullScreenDialog/FullScreenDialog'
import RemoveScrewModal from './Modals/RemoveScrewModal/RemoveScrewModal'
import { OtherTrayItemsProvider } from 'components/organisms/OtherTrayItems'
import OtherItemSelector from 'components/organisms/OtherTrayItems/OtherItemSelector'

function TrayVisualization() {
  const {
    trayType,
    mapContent,
    onClickActions,
    isScrewLoadedFromSPD,
    isScrewUsed,
    isScrewUsedAndWasted,
    handlePlateUsage,
    getInitialPlateCount,
    setSelectedPlate,
    setModalOpen,
    setSelectedScrew,
    handleConfirm,
    trayDetails,
    modalOpen,
    selectedStatus,
    setSelectedStatus,
    handleStatusChange,
    handleRemoveScrewModalClose,
    selectedScrews,
    selectedPlate,
    handlePlateStatusChange,
    otherItems,
    setOtherItems,
    otherItemsModalOpen,
    setOtherItemsModalOpen,
    handleAddOtherItemToUsage,
  } = useTrayVisualizationLogic()

  return (
    <OtherTrayItemsProvider items={otherItems} setItems={setOtherItems}>
      <FullScreenDialog open={true} onClose={() => {}}>
        <TransformWrapper
          initialScale={1}
          initialPositionX={0}
          initialPositionY={0}
          pinch={{
            step: 10,
          }}
          wheel={{
            step: 10,
          }}
          smooth
          doubleClick={{
            disabled: true,
          }}
        >
          <TrayProcedureEditMode
            trayType={trayType}
            mapContent={mapContent}
            onClose={() => {}}
            onClickActions={onClickActions}
            isScrewEnabled={isScrewLoadedFromSPD}
            isScrewImplanted={isScrewUsed}
            isScrewWasted={isScrewUsedAndWasted}
            handlePlateUsage={handlePlateUsage}
            getPlateCount={getInitialPlateCount}
            setSelectedPlate={setSelectedPlate}
            setModalOpen={setModalOpen}
            setOtherTrayItemsModalOpen={setOtherItemsModalOpen}
            setSelectedScrew={setSelectedScrew}
            handleConfirm={handleConfirm}
            trayDetails={trayDetails}
          />
        </TransformWrapper>
      </FullScreenDialog>

      <RemoveScrewModal
        trayType={trayType}
        open={modalOpen}
        onClose={handleRemoveScrewModalClose}
        selectedScrews={selectedScrews}
        selectedPlate={selectedPlate}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        handleStatusChange={
          selectedPlate ? handlePlateStatusChange : handleStatusChange
        }
      />

      <OtherItemSelector
        open={otherItemsModalOpen}
        onClose={() => setOtherItemsModalOpen(false)}
        otherItems={otherItems}
        onAddToUsage={handleAddOtherItemToUsage}
      />
    </OtherTrayItemsProvider>
  )
}

export default TrayVisualization
